class BoldPdpCustomizer {
  constructor(config = {}) {
    // Selectors configurable, if the HTML changes
    this.sel = {
      tooltipToMove:
        ".bold_option.bold_option_swatch:not(:has(.bold_option_value:nth-child(2))) > .bold_tooltip",
      metaobjectsScript: "script#pdp-section-blocks",
      renderOrderScript: "script#pdp-section-order",
      boldBlocks:
        ".bold_option.bold_option_swatch, .bold_option.bold_option_dropdown, .bold_option.bold_option_radio, .variant-wrapper.variant-wrapper--dropdown",
      optionsRoot: ".bold_options.bold_options_loaded",
      optionsTotal: ".bold_option_total",
      productPrice: "[data-product-price] .visually-hidden",
      swatchBlocksWithImages:
        '.bold_option_swatch:has(span[style^="background-image"])',
      imageSwatches:
        '.bold_option_value_swatch:has(span[style^="background-image"])',
    };

    this.config = {
      ...config,
    };

    // buckets
    this.metaobjectBlocks = [];
    this.shippingBlocks = [];
    this.deliveryBlocks = [];
    this.requiredDropdownBlocks = [];
    this.optionalDropdownBlocks = [];
    this.radioBlocks = [];
    this.genericBlocks = [];
    this.optionalRadioBlocks = [];
    this.parentElement = null;
    this.colorSwatchesBlocks = [];
    this.processedBlocks = new Set();

    // observer for total price
    this.priceObserver = null;
  }

  init() {
    // Main event of BOLD
    if (
      typeof window.BOLD === "undefined" ||
      !window.BOLD?.common?.eventEmitter
    ) {
      // In stores that delay BOLD, we try again on the next tick
      document.addEventListener("readystatechange", () => {
        if (document.readyState === "complete") this.init();
      });
      return;
    }

    BOLD.common.eventEmitter.on("BOLD_OPTIONS_option_products_loaded", () =>
      this.onOptionsLoaded()
    );
  }

  onOptionsLoaded() {
    try {
      this.moveTooltipIcons();
      this.getMetaobjectsTitlesAndTexts();
      this.metaobjectBlocks = this.getMetaobjectsBlocks();
      this.bucketizeBoldBlocks(); // divide em grupos e remove dos lugares originais
      this.renderSectionsInOrder();
      this.adjustSwatchesLayoutAndTooltips();
      this.setupTotalPrice();
      this.moveToOptionsLoaded();
    } catch (err) {
      console.error("[BoldPdpCustomizer] Error:", err);
    }
  }

  // --- UTIL ---------------------------------------------

  qsAll(selector, root = document) {
    return Array.from(root.querySelectorAll(selector));
  }

  // --- 1) Ajuste de tooltips simples ---------------------

  moveTooltipIcons() {
    this.qsAll(this.sel.tooltipToMove).forEach((tooltip) => {
      const parent = tooltip.parentElement;
      const label = parent?.querySelector("label");
      if (label) label.appendChild(tooltip);
    });
  }

  getMetaobjectsTitlesAndTexts() {
    const el = document.querySelector("script#pdp-section-metaobjects-title");
    if (!el?.textContent) {
      this.optionalMetaobjectsTitle = 'Must Haves';
      this.optionalDeliveryTitle = 'Delivery Information';
      this.optionalDeliveryDescription = '';
      return;
    }
    const data = JSON.parse(el.textContent);
    this.optionalMetaobjectsTitle = data.optional_metaobjects_title || 'Must Haves';
    this.optionalDeliveryTitle = data.optional_delivery_title || 'Delivery Information';
    this.optionalDeliveryDescription = data.optional_delivery_description || '';
  }

  // --- 2) Metaobjects (JSON vindo do script) -------------

  getMetaobjectsBlocks() {
    const el = document.querySelector(this.sel.metaobjectsScript);

    let data;
    try {
      data = JSON.parse(el.textContent);
    } catch {
      return [];
    }

    // garante o array e zera a propriedade blocks
    data.forEach((mo) => (mo.blocks = []));
    return data;
  }

  // --- 3) Section Builder -------------------------------

  highlightSection(
    parent,
    blocks,
    sectionName,
    sectionDescription,
    position,
    newClass,
    sectionDescriptionBelow = '',
    additionalClassToBlocks = ''
  ) {
    if (!parent || !blocks?.length) return;

    const wrap = document.createElement("div");
    wrap.classList.add("block_section");

    if (sectionName) {
      const name = document.createElement("span");
      name.classList.add("block_section__name");
      name.innerHTML = sectionName;
      wrap.appendChild(name);
    }

    if (sectionDescription) {
      const desc = document.createElement("span");
      desc.classList.add("block_section__description");
      desc.innerHTML = sectionDescription;
      wrap.appendChild(desc);
    }

    const blocksWrap = document.createElement("div");
    blocksWrap.classList.add("block_section__blocks");

    blocks.forEach((node) => {
      if (!node) return;
      if (newClass) node.classList.add(newClass);
      blocksWrap.appendChild(node);
    });

    wrap.appendChild(blocksWrap);

    if (sectionDescriptionBelow) {
      const descBelow = document.createElement("span");
      descBelow.classList.add("block_section__description");
      descBelow.innerHTML = sectionDescriptionBelow;
      wrap.appendChild(descBelow);
    }

    parent.insertAdjacentElement(position, wrap);
  }

  moveToOptionsLoaded() {
    const dynamicVariantsEnabled = document.querySelector('[data-dynamic-variants-enabled]');
    const boldOptionsLoaded = document.querySelector('.bold_options_loaded');
    console.log(dynamicVariantsEnabled, boldOptionsLoaded);

    if (dynamicVariantsEnabled && boldOptionsLoaded && !boldOptionsLoaded.contains(dynamicVariantsEnabled)) {
      boldOptionsLoaded.insertBefore(dynamicVariantsEnabled, boldOptionsLoaded.firstChild);
    }
  }

  // --- 4) Bucketize Bold Blocks -----------------------

  bucketizeBoldBlocks() {
    const boldBlocks = this.qsAll(this.sel.boldBlocks);
    console.log(boldBlocks)
    if (!boldBlocks.length) return;
  
    this.parentElement = boldBlocks[0]?.parentElement ?? null;
  
    for (const block of boldBlocks) {
      const hasOptionsSelector = block.querySelector(
        '.bold_option_element:has(.bold_option_value:nth-child(2))'
      );
      if (hasOptionsSelector) {
        this.handleRadioGroup(block);
      }
    }
  
    // 2️⃣ Second pass: bucketize the rest
    for (const block of boldBlocks) {
      if (this.processedBlocks.has(block) || block.classList.contains('variant-wrapper')) continue;
  
      if (block.classList.contains('bold_option_hidden')) {
        block.style.display = 'none';
        continue;
      }
  
      const swatchTitleEl = block.querySelector('.bold_option_swatch_title');
      if (swatchTitleEl) {
        const title = (swatchTitleEl.innerHTML || '').toLowerCase();
  
        if (title.includes('free shipping')) {
          block.remove();
          this.shippingBlocks.push(block);
          continue;
        }
  
        if (title.includes('delivery')) {
          block.remove();
          this.deliveryBlocks.push(block);
          continue;
        }
  
        let matchedMetaobject = false;
        for (const mo of this.metaobjectBlocks) {
          if (mo?.brand_title) {
            const brandWords = mo.brand_title.toLowerCase().split('/');
            if (brandWords.some(word => title.includes(word))) {
              block.remove();
              mo.blocks.push(block);
              matchedMetaobject = true;
              break;
            }
          }
        }
        if (matchedMetaobject) continue;
  
        block.remove();
        this.genericBlocks.push(block);
        continue;
      }
  
      if (
        block.classList.contains('bold_option_dropdown') ||
        block.classList.contains('variant-wrapper--dropdown')
      ) {
        const title = block.querySelector('.bold_option_title');
        block.remove();
        if (title && title.innerHTML.toLowerCase().includes('*') ) {
          const tooltip = title.parentElement.querySelector('.bold_tooltip');
          if (tooltip) {
            title.appendChild(tooltip);
          }
          this.requiredDropdownBlocks.push(block);
        } else {
          this.optionalDropdownBlocks.push(block);
        }
      }
    }
  }
  

  handleRadioGroup(block) {

  const titleEl = block.querySelector('.bold_option_title');
  const isColor = titleEl && (titleEl.innerHTML || '').toLowerCase().includes('color');

  // === RADIO TRANSFORM LOGIC (keep this first) ===

  if (isColor) {
    titleEl.classList.add('color_radio_option_title');
  }

  const parentElement = block.parentElement;

  if (parentElement) {
    const dropdownElements = parentElement.querySelectorAll('.bold_option_dropdown');

    dropdownElements.forEach(dropdown => {
      const selectElement = dropdown.querySelector('select');

      if (selectElement) {
        const option = selectElement.querySelector('option');
        if (option && option.innerHTML.includes('/')) {
          dropdown.classList.add('bold_option_related_to_radio');

          const label = dropdown.querySelector('label');
          const tooltip = dropdown.querySelector('.bold_tooltip');
          if (label && tooltip) {
            const prevTitle = label.querySelector('.bold_option_title');
            if (prevTitle) prevTitle.appendChild(tooltip);
          }

          dropdown.remove();
          this.radioBlocks.push(dropdown);
          this.processedBlocks.add(dropdown);
          return;
        }
      }

      const nextSibling = dropdown.nextElementSibling;
      if (nextSibling === block) {
        const label = dropdown.querySelector('label');
        const tooltip = dropdown.querySelector('.bold_tooltip');
        if (label && tooltip) {
          const prevTitle = label.querySelector('.bold_option_title');
          if (prevTitle) prevTitle.appendChild(tooltip);
        }

        this.optionalRadioBlocks.push(dropdown);
        dropdown.remove();
        this.processedBlocks.add(dropdown);
      }
    });
  }

  // Remove block from DOM before re-bucketing
  block.remove();

  // ==========================================================
  // 🔥 NEW SECTION — METAOBJECT CHECK INSIDE RADIO HANDLER
  // ==========================================================

  const groupTitleEl =
    block.querySelector(':scope > .bold_option_swatch_title') ||
    block.querySelector(':scope > .bold_option_title');

  if (groupTitleEl) {
    const title = groupTitleEl.textContent.trim().toLowerCase();

    for (const mo of this.metaobjectBlocks) {
      if (mo?.brand_title) {
        const brandWords = mo.brand_title.toLowerCase().split('/');

        if (brandWords.some(word => title.includes(word.trim()))) {

          // Send radio block to metaobject bucket
          block.classList.add("radio_option")
          mo.blocks.push(block);
          this.processedBlocks.add(block);
          return; // IMPORTANT: stop here
        }
      }
    }
  }

  // ==========================================================
  // If NOT matched to metaobject → normal radio classification
  // ==========================================================

  if (isColor) {
    const title = document.createElement('div');
    title.classList.add('bold_option_title');
    title.innerHTML = titleEl.innerHTML;
    this.colorSwatchesBlocks.push(title);
    this.colorSwatchesBlocks.push(block);
  } else {
    if (block.classList.contains('bold_option_swatch')) {
      this.optionalRadioBlocks.push(block);
    } else {
      this.genericBlocks.push(block);
    }
  }

  this.processedBlocks.add(block);
}
  

  // --- 5) Render in order --------------------------

  getRenderOrder() {
    const el = document.querySelector(this.sel.renderOrderScript);
    if (!el?.textContent) {
      return [
        "Free Shipping",
        "Radio Buttons",
        "Required Dropdowns",
        "Color Swatches",
        "Optional Metaobjects",
        "Additional Options",
        "Optional Dropdowns",
        "Delivery Information", 
      ];
    }

    try {
      const parsed = JSON.parse(el.textContent);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }

  renderSectionsInOrder() {
    if (!this.parentElement) return;

    const order = this.getRenderOrder();

    // mapa de render
    const map = {
      "Free Shipping": () =>
        this.highlightSection(
          this.parentElement,
          this.shippingBlocks,
          "Free Shipping",
          "",
          "beforeend",
          "free_shipping_option"
        ),
      "Radio Buttons": () =>
        this.highlightSection(
          this.parentElement,
          this.radioBlocks,
          "",
          "",
          "beforeend",
          "radio_option"
        ),
      "Required Dropdowns": () =>
        this.highlightSection(
          this.parentElement,
          this.requiredDropdownBlocks,
          "",
          "",
          "beforeend",
          "required_dropdown"
        ),
      "Optional Dropdowns": () =>
        this.highlightSection(
          this.parentElement,
          this.optionalDropdownBlocks,
          "",
          "",
          "beforeend",
          "optional_dropdown"
        ),
      "Recommended Metaobjects": () => {
        this.metaobjectBlocks.forEach((mo) => {
          this.highlightSection(
            this.parentElement,
            mo.blocks,
            mo.section_title,
            mo.section_description,
            "beforeend",
            "optional_metaobjects_option",
            mo.section_description_below,
            'recommended_metaobjects_option'
          );
        });
      },
      "Additional Options": () => {
        this.highlightSection(
          this.parentElement,
          this.genericBlocks,
          this.optionalMetaobjectsTitle,
          "",
          "beforeend",
          "additional_option"
        )
        this.highlightSection(
          this.parentElement,
          this.optionalRadioBlocks,
          "",
          "",
          "beforeend",
          "radio_option"
        )
      },
      "Color Swatches": () =>
        this.highlightSection(
          this.parentElement,
          this.colorSwatchesBlocks,
          "",
          "",
          "beforeend",
          "color_swatch_option"
        ),
      "Delivery Information": () =>
        this.highlightSection(
          this.parentElement,
          this.deliveryBlocks,
          this.optionalDeliveryTitle,
          this.optionalDeliveryDescription,
          "beforeend",
          "delivery_option"
        ),
    };

    order.forEach((key) => {
      if (typeof map[key] === "function") map[key]();
    });
  }

  // --- 6) Visual adjustments for swatches and tooltips --------

  adjustSwatchesLayoutAndTooltips() {
    // a) swatch blocks com imagem: se tiver >1 valor, empilha título acima
    this.qsAll(this.sel.swatchBlocksWithImages).forEach((el) => {
      const values = el.querySelectorAll(".bold_option_value");
      if (values.length > 1) {
        el.style.flexDirection = "column";
        const title = el.querySelector(".bold_option_title");
        if (title) title.style.display = "block";
      }
    });

    // b) each item of swatch with image => move checkbox and information
    this.qsAll(this.sel.imageSwatches).forEach((swatch) => {
      const itemRow = swatch.parentElement; // usually the <li> or wrapper of the item
      const checkbox = itemRow?.children?.[1];
      const parent = itemRow?.parentElement; // list
      const info = parent?.children?.[1]; // infos to the right (name/price)

      if (checkbox) {
        checkbox.style.marginLeft = "auto";
        checkbox.style.display = "block";
        if (parent?.append) parent.append(checkbox);
      }

      if (info?.children?.[1] && info?.children?.[0]) {
        // add secondary label to the primary
        const primary = info.children[0];
        const secondary = info.children[1];
        primary.innerHTML +=
          "<br><span style='font-size:13px; font-weight:300;'>" +
          secondary.textContent +
          "</span>";
        primary.style.lineHeight = "1";
        secondary.style.display = "none";
      }
    });

    // c) reposition tooltip in swatches with image
    this.qsAll(this.sel.swatchBlocksWithImages).forEach((block) => {
      const label = block.querySelector("label");
      const title = block.querySelector(".bold_option_title");
      const tooltip = block.querySelector(".bold_tooltip");
      if (tooltip && label) {
        if (block.classList.contains("radio_option")) {
          if (title) title.appendChild(tooltip);
        } else {
          label.insertBefore(tooltip, label.firstElementChild);
        }
      }
    });
  }

  // --- 7) Total price (product + options) -----------------

  setupTotalPrice() {
    const container = document.querySelector(this.sel.optionsRoot);
    if (!container) return;

    // encerra observador antigo (se houver)
    if (this.priceObserver) {
      this.priceObserver.disconnect();
      this.priceObserver = null;
    }

    this.priceObserver = new MutationObserver(() => this.updateTotalPrice());
    this.priceObserver.observe(container, { childList: true, subtree: true });

    this.updateTotalPrice();
  }

  parsePriceString(raw) {
    if (!raw) return 0;
    // keep compatible with $ and separators of the themes
    let s = String(raw).trim();
    if (s.includes("$")) s = s.replace("$", "").replace(",", "");
    // fallback for numbers with symbol in other currencies: remove everything that is not number/point/comma
    s = s.replace(/[^\d.,-]/g, "");
    // normalize comma if it comes as decimal separator
    if (s.indexOf(",") > -1 && s.indexOf(".") === -1) s = s.replace(",", ".");
    const n = Number.parseFloat(s);
    return Number.isFinite(n) ? n : 0;
  }

  formatPrice(value, currencySymbol) {
    const formatted = value.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return `${currencySymbol} ${formatted}`;
  }

  makePriceElement(totalPrice, originalPrice, currencySymbol) {
    const total = this.formatPrice(totalPrice, currencySymbol).split(".");
    const orig = this.formatPrice(originalPrice, currencySymbol).split(".");

    const wrap = document.createElement("div");
    wrap.classList.add("price-element");

    const label = document.createElement("div");
    label.classList.add("price-element__label");
    label.textContent = "Total:";

    const value = document.createElement("div");
    value.classList.add("price-element__value");
    value.textContent = total[0];
    const valueSup = document.createElement("sup");
    valueSup.classList.add("price-element__value-sup");
    valueSup.textContent = total[1] || "00";
    value.appendChild(valueSup);

    const original = document.createElement("div");
    original.classList.add("price-element__original-price");
    original.textContent = orig[0];
    const originalSup = document.createElement("sup");
    originalSup.classList.add("price-element__original-price-sup");
    originalSup.textContent = orig[1] || "00";
    original.appendChild(originalSup);

    wrap.appendChild(label);
    wrap.appendChild(value);
    wrap.appendChild(original);

    return wrap;
  }

  updateTotalPrice() {
    const container = document.querySelector(this.sel.optionsRoot);
    const boldTotalEl = document.querySelector(this.sel.optionsTotal);
    const productPriceEl = document.querySelector(this.sel.productPrice);
    if (!container || !productPriceEl) return;

    const boldOptionsTotalValue =
      boldTotalEl?.querySelector("span")?.textContent ?? "0.00";

    // currency symbol is taken from the entire price string of the product
    const productPriceRaw = productPriceEl.textContent || "";
    const currencySymbol = (productPriceRaw.split(" ")[0] || "").trim();

    const optionsPrice = this.parsePriceString(boldOptionsTotalValue);
    const productPrice = this.parsePriceString(productPriceRaw);
    const totalPrice = productPrice + optionsPrice;

    const existing = container.parentElement.querySelector(".price-element");
    if (existing) existing.remove();

    const priceElement = this.makePriceElement(
      totalPrice,
      productPrice,
      currencySymbol || "$"
    );
    container.after(priceElement);
  }
}

// Boot public
function boot() {
  const app = new BoldPdpCustomizer();
  app.init();
}

document.addEventListener('DOMContentLoaded', boot);